import React from 'react';
//simple funtion component
const Header = () => {

    return (
        <header>
            <h1>ToDoList</h1>
        </header>
    )
}

export default Header;